import { useUserHasFeature } from '@chilipiper/license'

export const useUserHasLiveChatLicense = (): boolean => useUserHasFeature()('LiveChat', 'chat')
